import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import Button from "../Global/Buttons/Button";
import ContentList from '../Global/Lists/ContentList';
import ExpandFolderButton from "./ExpandFolderButton";
import Icon from "../Global/Icons/Icon";
import NoResultsMessage from '../Global/Messages/NoResultsMessage';
import VerticalTextLockup from "../Global/Typography/VerticalTextLockup";

const FoldersList = ({ folders, folderClick, arrowClick, homeClick, activeItems, expandedFolders, loading }) => {
  if (folders.length > 0) {
    const homeFolder = { id: null, title: `Home` };
    let checkboxClass;
    if (homeClick) {
      checkboxClass = classNames(
        `checkbox-input`,
        { 'checkbox-input--checked': activeItems.includes(homeFolder.id) },
      );
    }
    const homeFolderClass = classNames({
      'folder-icon-btn--disabled': !homeClick,
    });

    return (
      <ContentList>
        <li className="d-flex bg-grey--lightest">

          <Button onClick={() => { if (homeClick) homeClick(homeFolder.id); }} faux disabled={!homeClick} classes={homeFolderClass}>
            <Icon name="folder-home" fill="blue" size="m" />
            <VerticalTextLockup
              title={<h3 className="like-p">{homeFolder.title}</h3>}
            />
            <span className={checkboxClass} />
            <span className="faux-label" />
          </Button>
        </li>
        {folders.map((folder) => {
          // hide child folders if the parent has not been expanded
          if (folder.parent_id !== null && !expandedFolders.has(folder.parent_id)) {
            return null;
          }

          return (
            <ExpandFolderButton
              key={folder.id}
              folder={folder}
              folderClick={folderClick}
              arrowClick={arrowClick}
              active={activeItems.includes(folder.id)}
              expanded={expandedFolders.has(folder.id)}
              disabled={!homeClick ? folder.contain_content : false}
            />
          );
        })}
      </ContentList>
    );
  }

  return (
    <NoResultsMessage
      title="You don't currently have any folders"
      text="Folders are a great way of organising content to share with your teams. Click the 'Create new' link above to get started."
      loading={loading}
    />
  );
};

FoldersList.propTypes = {
  folders: PropTypes.array.isRequired,
  folderClick: PropTypes.func.isRequired,
  arrowClick: PropTypes.func.isRequired,
  homeClick: PropTypes.func,
  activeItems: PropTypes.array,
  expandedFolders: PropTypes.object,
  loading: PropTypes.bool,
};

export default FoldersList;



// WEBPACK FOOTER //
// ./library/app/components/Folders/AddToFoldersList.js